import type { ComponentType, MouseEventHandler, ReactNode } from 'react'

import { cn } from '@/utils/style'

interface UserDropdownItemProps {
  icon: ComponentType<{ className?: string }>
  label: ReactNode
  /** Trailing element on the right side, e.g. arrow / external link icon */
  trailing?: ReactNode
  active?: boolean
  className?: string
  onClick?: MouseEventHandler<HTMLDivElement>
}

/**
 * Single row inside the user dropdown menu.
 * Layout follows Figma `_SettingItem`: 8px-padded 16px icon, 14px semibold label, optional trailing icon.
 */
export function UserDropdownItem({
  icon: Icon,
  label,
  trailing,
  active,
  className,
  onClick,
}: UserDropdownItemProps) {
  return (
    <div
      className={cn(
        'flex w-full cursor-pointer items-center gap-2 rounded-lg pr-2 hover:bg-panel-gray-100',
        active && 'bg-panel-gray-100',
        className,
      )}
      onClick={onClick}
    >
      <span className="flex shrink-0 p-2">
        <Icon className="h-4 w-4 text-secondary" />
      </span>
      <span className="t-sm min-w-0 flex-1 truncate">{label}</span>
      {trailing}
    </div>
  )
}
